import { supabase } from './supabaseClient.js';
// The maximum number of rows returns from a view, table, or stored procedure.
// Limits payload size for accidental or malicious requests.
// Same as in https://app.supabase.io/project/[projectId]/settings/api -> Settings -> Max Rows
const MAX_ROWS = 1000;
const USER_ANSWER_TABLE_NAME = 'user_answer';
const USER_ID_COLUMN_NAME = 'user_id';
const ANSWER_COLUMN_NAME = 'answers';
export async function saveUserAnswers(userId, answerList) {
    const record = {
        [USER_ID_COLUMN_NAME]: userId,
        [ANSWER_COLUMN_NAME]: answerList,
    };
    const { data, error } = await supabase
        .from(USER_ANSWER_TABLE_NAME)
        // NOTE: By default, every time you run insert(), the client library will make a select to return the full record.
        // This is convenient, but it can also cause problems if your Policies are not configured to allow the select operation.
        // If you are using Row Level Security and you are encountering problems, try setting the `returning` param to `minimal`.
        .insert(record, { returning: 'minimal' });
    if (error) {
        console.error('[saveUserAnswers] Something went wrong.');
        throw new Error(error.message);
    }
    return data;
}
export async function userAnswers(userId) {
    const { data, error } = await supabase
        .from(USER_ANSWER_TABLE_NAME)
        .select(ANSWER_COLUMN_NAME)
        .eq(USER_ID_COLUMN_NAME, userId);
    if (error) {
        console.error('[userAnswers] Something went wrong.');
        throw new Error(error.message);
    }
    if (data.length === 0) {
        console.warn(`[userAnswers] There are no data for the user ${userId}.`);
        return null;
    }
    const answers = data[0].answers;
    console.log('[BE] userAnswers - answers: ', answers);
    return answers;
}
// NOTE: keep in mind that by default, Supabase projects will return a maximum of 1000 rows
export async function usersAnswers(requestedRange) {
    const { data, count, error } = await supabase
        .from(USER_ANSWER_TABLE_NAME)
        .select('*', { count: 'exact' })
        .range(...requestedRange);
    if (error) {
        console.error('[usersAnswers] Something went wrong.');
        throw new Error(error.message);
    }
    if (data.length === Math.min(count, requestedRange[1] - requestedRange[0])) {
        console.log('[BE] usersAnswers - data: ', data);
        return { data, count };
    }
    else {
        console.log(`[BE] usersAnswers - data page 1: `, data);
        while (data.length < count) {
            const res = await usersAnswers([data.length, count]);
            console.log(`[BE] usersAnswers - data page X: `, res.data);
            data.push(...res.data);
        }
        console.log('[BE] usersAnswers - data concatenated: ', data);
        return { data, count };
    }
}
export async function totalUsersCounter() {
    const { data, error, count } = await tableCount(USER_ANSWER_TABLE_NAME);
    if (error) {
        console.error('[totalUsersCounter] Something went wrong.');
        throw new Error(error.message);
    }
    console.log('[BE] totalUsersCounter - count: ', count);
    return count;
}
async function tableCount(tableName) {
    const { data, error, count } = await supabase
        .from(tableName)
        .select('*', { count: 'exact', head: true });
    return { data, error, count };
}
